import { Checkbox, List, ListItem, ListItemIcon, ListItemText, Popover } from '@material-ui/core';
import CustomButton from 'components/CustomInput/Button';
import useApplicationTableData from 'hooks/useApplicationData';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateApplicationColumn } from 'store/column/reducer';
import styled from 'styled-components/macro';
import { produce } from 'utility/general';
import { APPLICANT } from 'utility/lookup';

const SLayout = styled.div``;

const ApplicationColumnButton = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const applicationColumn = useSelector((state) => state.column.application);
    const { rawColumn } = useApplicationTableData({});
    const user = useSelector((state) => state.user);

    const getColumnSelection = () => {
        return rawColumn
            .filter((item) => item.field !== 'id')
            .filter((item) => !item.hiddenInTableColumn && !item.disableInColumnSelect)
            .filter((item) => {
                if (item.field === 'lastHandledBy' && user.role === APPLICANT) {
                    return false;
                }

                return true;
            });
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const updateChecked = (key) => {
        const newApplicationColumn = produce(applicationColumn, (draft) => {
            const index = draft.findIndex((item) => item.key === key);

            if (index !== -1) {
                draft.splice(index, 1);
            } else {
                const defaultObject = rawColumn.find((item) => item.field === key);
                draft.push({ key, width: defaultObject?.width || 100 });
            }
        });

        dispatch(updateApplicationColumn(newApplicationColumn));
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <SLayout>
            <CustomButton onClick={handleClick}>Hide/Show Columns</CustomButton>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <List>
                    {getColumnSelection().map((value) => {
                        const labelId = `checkbox-list-label-${value.field}`;

                        const isChecked = applicationColumn.some((item) => {
                            return item.key === value.field;
                        });

                        return (
                            <ListItem
                                dense
                                key={value.headerName}
                                button
                                onClick={() => {
                                    if (!value.mandatory) {
                                        updateChecked(value.field);
                                    }
                                }}
                            >
                                <ListItemIcon style={{ minWidth: 25 }}>
                                    <Checkbox
                                        disabled={value.mandatory}
                                        edge="start"
                                        checked={isChecked}
                                        tabIndex={-1}
                                        disableRipple
                                        style={{ padding: 3 }}
                                        inputProps={{ 'aria-labelledby': labelId }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={labelId} primary={value.headerName} />
                            </ListItem>
                        );
                    })}
                </List>
            </Popover>
        </SLayout>
    );
};

export default ApplicationColumnButton;
